import { memo, useEffect, useState } from 'react';

import { twMerge } from 'tailwind-merge';

import { HoverCard, HoverCardContent, HoverCardTrigger } from '@/_components';

import { FileIcon } from './file-icon';

interface FilePreviewProps {
  filename: string;
  fileUrl?: string;
  mimeType: string;
}

function FilePreviewComponent({ filename, fileUrl, mimeType }: FilePreviewProps) {
  const [imageLoaded, setImageLoaded] = useState(false);
  const [imageError, setImageError] = useState(false);

  useEffect(() => {
    setImageLoaded(false);
    setImageError(false);
  }, [fileUrl]);

  const isImageType = mimeType.startsWith('image/');

  const fileIcon = <FileIcon filename={filename} />;

  if (!isImageType || !fileUrl || imageError) {
    return fileIcon;
  }

  return (
    <HoverCard openDelay={150} closeDelay={150}>
      <HoverCardTrigger asChild>
        <div className="flex size-8 min-h-8 min-w-8 items-center justify-center overflow-hidden rounded-md bg-gray-100">
          <img
            src={fileUrl}
            alt={filename}
            className={twMerge(
              'h-full w-full object-cover transition-opacity duration-200',
              imageLoaded ? 'opacity-100' : 'opacity-0'
            )}
            onLoad={() => setImageLoaded(true)}
            onError={() => setImageError(true)}
          />
        </div>
      </HoverCardTrigger>
      <HoverCardContent
        side="top"
        align="start"
        className="bg-c-avatar! dark:bg-c-avatar! w-auto overflow-hidden border-0 p-2 shadow-xl"
      >
        <div className="flex flex-col items-center">
          <img
            src={fileUrl}
            alt={filename}
            className="max-h-50 max-w-75 min-w-50 rounded-md object-contain"
            onLoad={() => setImageLoaded(true)}
          />
        </div>
      </HoverCardContent>
    </HoverCard>
  );
}

export const FilePreview = memo(FilePreviewComponent);
